/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateSignaturePayloadV1Dto } from '../models/ActivateSignaturePayloadV1Dto';
import type { ActivateSignatureResponseV1Dto } from '../models/ActivateSignatureResponseV1Dto';
import type { CreateSignerPayloadV1Dto } from '../models/CreateSignerPayloadV1Dto';
import type { CreateSignerResponseV1Dto } from '../models/CreateSignerResponseV1Dto';
import type { InitiateSignaturePayloadV1Dto } from '../models/InitiateSignaturePayloadV1Dto';
import type { InitiateSignatureResponseV1Dto } from '../models/InitiateSignatureResponseV1Dto';
import type { UploadDocumentPayloadV1Dto } from '../models/UploadDocumentPayloadV1Dto';
import type { UploadDocumentResponseV1Dto } from '../models/UploadDocumentResponseV1Dto';
import type { WebhookPayloadDto } from '../models/WebhookPayloadDto';
import type { YouSignSignatureDtoV1 } from '../models/YouSignSignatureDtoV1';
import type { YouSignSignatureWithRequestResponseV1Dto } from '../models/YouSignSignatureWithRequestResponseV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class YouSignService {
  /**
   * @param uuid
   * @returns YouSignSignatureDtoV1 the entity
   * @throws ApiError
   */
  public static youSignControllerV1FindOneSignatureV1(
    uuid: string,
  ): CancelablePromise<YouSignSignatureDtoV1> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/you-sign/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param status Signature request status
   * @returns YouSignSignatureDtoV1 a entity list
   * @throws ApiError
   */
  public static youSignControllerV1FindManySignaturesV1(
    status?:
      | 'approval'
      | 'canceled'
      | 'declined'
      | 'deleted'
      | 'done'
      | 'draft'
      | 'expired'
      | 'initiated'
      | 'ongoing'
      | 'rejected',
  ): CancelablePromise<Array<YouSignSignatureDtoV1>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/you-sign',
      query: {
        status: status,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns InitiateSignatureResponseV1Dto create entity
   * @throws ApiError
   */
  public static youSignControllerV1InitiateNewSignatureV1(
    requestBody: InitiateSignaturePayloadV1Dto,
  ): CancelablePromise<InitiateSignatureResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/you-sign/initiate-signature',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param signatureRequestId
   * @param requestBody
   * @returns UploadDocumentResponseV1Dto create entity
   * @throws ApiError
   */
  public static youSignControllerV1UploadDocumentToSignatureRequestV1(
    signatureRequestId: string,
    requestBody: UploadDocumentPayloadV1Dto,
  ): CancelablePromise<UploadDocumentResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/you-sign/upload-document/{signatureRequestId}',
      path: {
        signatureRequestId: signatureRequestId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param signatureRequestId
   * @param requestBody
   * @returns CreateSignerResponseV1Dto create entity
   * @throws ApiError
   */
  public static youSignControllerV1CreateNewSignerV1(
    signatureRequestId: string,
    requestBody: CreateSignerPayloadV1Dto,
  ): CancelablePromise<CreateSignerResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/you-sign/create-signer/{signatureRequestId}',
      path: {
        signatureRequestId: signatureRequestId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns YouSignSignatureDtoV1 create entity
   * @throws ApiError
   */
  public static youSignControllerV1RequestSignatureV1(
    requestBody: YouSignSignatureWithRequestResponseV1Dto,
  ): CancelablePromise<YouSignSignatureDtoV1> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/you-sign/request-signature',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param signatureRequestId
   * @param requestBody
   * @returns ActivateSignatureResponseV1Dto create entity
   * @throws ApiError
   */
  public static youSignControllerV1ActivateSignatureV1(
    signatureRequestId: string,
    requestBody: ActivateSignaturePayloadV1Dto,
  ): CancelablePromise<ActivateSignatureResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/you-sign/activate/{signatureRequestId}',
      path: {
        signatureRequestId: signatureRequestId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static youSignWebhookControllerHandleWebhook(
    requestBody: WebhookPayloadDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/you-sign/webhook',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
